<template>
	<section class="page-create">
		<ScenePadCreator v-on:play="Handle_OnPlay" />
	</section>
</template>

<script lang="ts">
	import * as Service from '../Service';
	import ChalkySticks from '@chalkysticks/sdk';
	import PageBase from '@/Core/Page.vue';
	import { Component } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * Page controller for the pad diagrammer. Embeds the ViewCreatePad
	 * view and handles page-level navigation events.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PageCreate extends PageBase {
		/**
		 * Suspend geolocation to free resources for the pad creator.
		 *
		 * @return void
		 */
		@mounted
		public attachEvents(): void {
			Service.Location.suspend();
		}

		/**
		 * Resume geolocation if it was suspended.
		 *
		 * @return void
		 */
		@beforeDestroy
		public detachEvents(): void {
			Service.Location.resume();
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Handle play event from the pad view.
		 *
		 * @return Promise<void>
		 */
		protected async Handle_OnPlay(): Promise<void> {
			this.$router.push({
				name: 'PagePlay',
			});
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.page-create {
		background: radial-gradient(circle, rgba(33, 42, 56, 1) 50%, rgba(19, 25, 34, 1) 100%);
		height: 100%; // calc(100% - var(--global-tab-height));
		overflow: hidden;
		width: 100%;

		// hide for android too since we're in app mode already
		.action-fullscreen {
			display: none !important;
		}
	}

	// State
	// ---------------------------------------------------------------------------

	[page='PageCreate'] .view-layout-navigationtabs {
		display: none;
	}

	// Specifically targets devices where the primary input is touch and cannot hover
	@media (hover: none) and (pointer: coarse) {
		#app[page='PageCreate'] .ui-tooltip {
			display: none !important;
		}
	}
</style>
